import React, { useEffect, useState } from 'react';
import { Alert, Button, Col, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import TextInput from '../../pages/components/inputs/TextInput';
import { BlockHead, BlockTitle, Icon, RSelect } from '../Component';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { fail_retrieve_warehouse_sites, loading_retrieve_warehouse_sites, reset_retrieve_warehouse_sites, success_retrieve_warehouse_sites } from '../../reducers/auth_tenant/retrieve_warehouse_sites_Slice';
import { RETIREVE_WAREHOUSE_SITES_ERROR_MSG, RETIREVE_WAREHOUSE_SITES_SUCCESS_MSG, RETRIEVE_TENANT_STOCK_TAKE_STARTING_BALANCE_ERROR_MSG, RETRIEVE_TENANT_STOCK_TAKE_STARTING_BALANCE_SUCCESS_MSG, TENANT_CREATE_STOCK_TAKE_ERROR_MSG, TENANT_CREATE_STOCK_TAKE_SUCCESS_MSG } from '../../utils/error_success_messages';
import { RETRIEVE_TENANT_STOCK_TAKE_STARTING_BALANCE_API, RETRIEVE_TENANT_WAREHOUSE_SITES_BY_STATUS_API, TENANT_TENANT_CREATE_STOCK_TAKE_API } from '../../api/api_data';
import * as app_consts from "../../utils/app_consts";
import { useSelector } from 'react-redux';
import { messageToast } from '../../utils/Utils';
import { useDispatch } from 'react-redux';
import { fail_retrieve_tenant_stock_take_starting_balance, loading_retrieve_tenant_stock_take_starting_balance, reset_retrieve_tenant_stock_take_starting_balance, success_retrieve_tenant_stock_take_starting_balance } from '../../reducers/auth_tenant/retrieve_tenant_stock_take_starting_balance_Slice';
import { fail_tenant_create_stock_take, loading_tenant_create_stock_take, reset_tenant_create_stock_take, success_tenant_create_stock_take } from '../../reducers/auth_tenant/tenant_create_stock_take_Slice';
import { useNavigate } from 'react-router';

const initialState = { name: "", stock_balance_end_date: "", stock_balance_start_date: "", warehouse_site_id: "" };

const AddStockTakeModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal }) => {

 const [open, setOpen] = useState(isOpen);
 const [loading, setLoading] = useState(false);
 const dispatch = useDispatch();
 const navigate = useNavigate();
 const [error, setError] = useState("");
 const [warehouse_sites, setWarehouseSites] = useState([]);
 const [formData, setFormData] = useState(initialState);
 const [warehouse_sites_loading, setWarehouseSitesLoading] = useState(true);
 const [starting_balance_data, setStartingBalanceData] = useState({ starting_balance: "", products: "" });
 const [query_starting_balance_loading, setQueryStartingBalanceLoading] = useState(false);
 const [query_starting_balance_error, setQueryStartingBalanceError] = useState(false);

 useEffect(() => {
  setOpen(isOpen);
  setFormData(initialState);
  setStartingBalanceData("");
  setQueryStartingBalanceError("");

  if (isOpen)
  {
   setWarehouseSitesLoading(true);
   // Retrieve Active Warehouse Site
   dispatch(tenant_auth_actions_helper(loading_retrieve_warehouse_sites, success_retrieve_warehouse_sites, fail_retrieve_warehouse_sites, RETIREVE_WAREHOUSE_SITES_ERROR_MSG, RETIREVE_WAREHOUSE_SITES_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_WAREHOUSE_SITES_BY_STATUS_API}/${app_consts.ACTIVE}`));
  }
 }, [isOpen]);

 // Listen
 const retrieve_warehouse_sites_listener = useSelector((state) => state.retrieve_warehouse_sites.retrieve_warehouse_sites);

 useEffect(() => {
  if (retrieve_warehouse_sites_listener.status !== app_consts.IDLE)
  {
   if (retrieve_warehouse_sites_listener.status === app_consts.LOADING)
   {
    setWarehouseSitesLoading(true);
   } else
   {
    if (retrieve_warehouse_sites_listener.status === app_consts.FAIL)
    {
     setWarehouseSitesLoading(false);
     messageToast(retrieve_warehouse_sites_listener.message, app_consts.FAIL);
    } else if (retrieve_warehouse_sites_listener.status === app_consts.SUCCESS)
    {
     return_warehouse_sites(retrieve_warehouse_sites_listener.data);
    }
    dispatch(reset_retrieve_warehouse_sites());
   }
  }
 }, [retrieve_warehouse_sites_listener]);

 // Grouping Warehouse Sites
 const return_warehouse_sites = (sites) => {
  const ware_sites = sites?.map((item) => {
   return { label: item?.name, value: item?.id };
  });
  setWarehouseSites(ware_sites);
  const timer = setTimeout(() => {
   setWarehouseSitesLoading(false);
  }, 1000);

  return () => clearTimeout(timer); // cleanup in case the component unmounts
 };

 // Handle Change Function
 const handleChange = (e) => {
  setFormData({ ...formData, [e.target.name]: e.target.value });
 };

 const getSelectedOption = (value, options) => {
  return options?.find(option => option.value === value) || null;
 };

 const retrieve_stock_take_starting_balance = () => {
  setStartingBalanceData("");;
  setQueryStartingBalanceError("");
  setQueryStartingBalanceLoading(true);

  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = Math.abs(offsetMinutes) / 60;
  const offsetSign = offsetMinutes > 0 ? "-" : "+";
  const formattedOffset = `${offsetSign}${String(offsetHours).padStart(2, "0")}:00`;

  const parsed_start_date = `${formData?.stock_balance_start_date}${formattedOffset}`;
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_stock_take_starting_balance, success_retrieve_tenant_stock_take_starting_balance, fail_retrieve_tenant_stock_take_starting_balance, RETRIEVE_TENANT_STOCK_TAKE_STARTING_BALANCE_ERROR_MSG, RETRIEVE_TENANT_STOCK_TAKE_STARTING_BALANCE_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_STOCK_TAKE_STARTING_BALANCE_API}/${formData?.warehouse_site_id}/${parsed_start_date}`));
 };

 // Listen
 const retrieve_tenant_stock_take_starting_balance_listener = useSelector((state) => state.retrieve_tenant_stock_take_starting_balance.retrieve_tenant_stock_take_starting_balance);

 useEffect(() => {
  if (retrieve_tenant_stock_take_starting_balance_listener.status !== app_consts.IDLE)
  {
   if (retrieve_tenant_stock_take_starting_balance_listener.status === app_consts.LOADING)
   {
    setQueryStartingBalanceLoading(true);
    setQueryStartingBalanceError("");
   } else
   {
    setQueryStartingBalanceLoading(false);
    if (retrieve_tenant_stock_take_starting_balance_listener.status === app_consts.FAIL)
    {
     setQueryStartingBalanceError(retrieve_tenant_stock_take_starting_balance_listener.message);
     messageToast(retrieve_tenant_stock_take_starting_balance_listener.message, app_consts.FAIL);
    } else if (retrieve_tenant_stock_take_starting_balance_listener.status === app_consts.SUCCESS)
    {
     setStartingBalanceData(retrieve_tenant_stock_take_starting_balance_listener?.data);
    }
    dispatch(reset_retrieve_tenant_stock_take_starting_balance());
   }
  }
 }, [retrieve_tenant_stock_take_starting_balance_listener]);

 const handleCreateStockTake = () => {
  setError("");
  // Dispatch
  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = Math.abs(offsetMinutes) / 60;
  const offsetSign = offsetMinutes > 0 ? "-" : "+";
  const formattedOffset = `${offsetSign}${String(offsetHours).padStart(2, "0")}:00`;

  const req_data = { ...formData, stock_balance_start_date: `${formData?.stock_balance_start_date}${formattedOffset}`, stock_balance_end_date: `${formData?.stock_balance_end_date}${formattedOffset}` };
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_tenant_create_stock_take, success_tenant_create_stock_take, fail_tenant_create_stock_take, TENANT_CREATE_STOCK_TAKE_ERROR_MSG, TENANT_CREATE_STOCK_TAKE_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_TENANT_CREATE_STOCK_TAKE_API}`, req_data));
 };

 // Listen
 const tenant_create_stock_take_listener = useSelector((state) => state.tenant_create_stock_take.tenant_create_stock_take);

 useEffect(() => {
  if (tenant_create_stock_take_listener.status !== app_consts.IDLE)
  {
   if (tenant_create_stock_take_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    setLoading(false);
    if (tenant_create_stock_take_listener.status === app_consts.FAIL)
    {
     setError(tenant_create_stock_take_listener.message);
     messageToast(tenant_create_stock_take_listener.message, app_consts.FAIL);
    } else if (tenant_create_stock_take_listener.status === app_consts.SUCCESS)
    {
     navigate(`/${tenant_info?.url_prefix}/stock_take/${tenant_create_stock_take_listener?.data?.reference_number}`);
    }
    dispatch(reset_tenant_create_stock_take());
   }
  }
 }, [tenant_create_stock_take_listener]);


 return (
  <>
   < Modal isOpen={open} className="modal-dialog-centered" size={"lg"} >
    <ModalHeader toggle={loading ? "" : closeModal}>Add Stock Take</ModalHeader>
    <ModalBody>
     <Row className="g-4">
      <TextInput
       label="Name"
       type="text"
       id_val="name"
       value={formData?.name}
       colSize="6"
       required
       name="name"
       handleChange={handleChange}
      />
      <Col lg={6}>
       <div className="form-group">
        <div className="form-label-group">
         <label className="form-label">
          <label className="form-label mb text-md" htmlFor="retrunable">
           Warehouse Site Location<span className='text-danger pr-2'>{` *`}</span>
          </label>
         </label>
         <span>{warehouse_sites_loading && <Spinner size="sm" />}</span>
        </div>
        <div className="w-100">
         <RSelect
          options={warehouse_sites?.map((p) => {
           return (
            {
             label: p?.label,
             value: p?.value
            }
           );
          })}
          isDisabled={warehouse_sites_loading}
          className="w-100"
          placeholder="Search"
          value={getSelectedOption(formData?.warehouse_site_id, warehouse_sites)}
          onChange={(e) => { setFormData({ ...formData, warehouse_site_id: e?.value }); setStartingBalanceData(""); }}
         />
        </div>
       </div>
      </Col>
      <Col lg={6}>
       <div className="form-group">
        <label className="form-label mb-1 text-md" htmlFor="retrunable">
         Stock Balance Start Date<span className='text-danger pr-2'>{` *`}</span>
        </label>
        <div className="w-100">

         <input
          type="datetime-local"
          name="pre_auction_start_date"
          value={formData?.stock_balance_start_date}
          className="form-control"
          max={new Date().toISOString().slice(0, 16)}
          onChange={(e) => setFormData({ ...formData, stock_balance_start_date: e.target.value })}
         />
        </div>
       </div>
      </Col>
      <Col lg={6}>
       <div className="form-group">
        <label className="form-label mb-1 text-md" htmlFor="retrunable">
         Stock Balance End Date<span className='text-danger pr-2'>{` *`}</span>
        </label>
        <div className="w-100">

         <input
          type="datetime-local"
          name="pre_auction_start_date"
          value={formData?.stock_balance_end_date}
          className="form-control"
          max={new Date().toISOString().slice(0, 16)}
          min={formData?.stock_balance_start_date}
          onChange={(e) => setFormData({ ...formData, stock_balance_end_date: e.target.value })}
          disabled={!formData?.stock_balance_start_date}
         />
        </div>
       </div>
      </Col>
     </Row>
     <BlockHead className="mt-4">
      <BlockTitle tag="h6">Starting Balance</BlockTitle>
     </BlockHead>
     <Row className="g-4">
      <TextInput
       label="Starting Balance"
       type="text"
       id_val="starting_balance"
       value={starting_balance_data?.starting_balance && (`${starting_balance_data?.starting_balance} Units`)}
       colSize="6"
       required
       disabled
       name="starting_balance"
      />
      <TextInput
       label="No of Products"
       type="text"
       id_val="products"
       value={starting_balance_data?.products}
       colSize="6"
       required
       disabled
       name="products"
      />
      {query_starting_balance_error && (
       <div className="mb-3 w-100">
        <Alert color="danger" className="alert-icon">
         <Icon name="alert-circle" />{query_starting_balance_error}{" "}
        </Alert>
       </div>
      )}
      <Col xl="12" className="d-flex justify-content-start mt-2 mr-2">
       <Button onClick={retrieve_stock_take_starting_balance} disabled={
        (query_starting_balance_loading || loading) ||
        !(formData?.name && formData?.stock_balance_end_date && formData?.stock_balance_start_date && formData?.warehouse_site_id)
       } color="primary">
        {query_starting_balance_loading ? <Spinner size="sm" color="light" /> : "Query"}
       </Button>
      </Col>
     </Row>
     <hr />
     <Row className="g-4 mt-4">
      {error && (
       <div className="mb-3 w-100">
        <Alert color="danger" className="alert-icon">
         <Icon name="alert-circle" /> {error}{" "}
        </Alert>
       </div>
      )}
      <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
       <Button onClick={handleCreateStockTake} disabled={
        (query_starting_balance_loading || loading) ||
        !(formData?.name && formData?.stock_balance_end_date && formData?.stock_balance_start_date && formData?.warehouse_site_id && starting_balance_data?.starting_balance && starting_balance_data?.products)
       } color="primary">
        {loading ? <Spinner size="sm" color="light" /> : "Add Stock Take"}
       </Button>
      </Col>
     </Row>

    </ModalBody>
   </Modal>


  </>
 );
};

export default AddStockTakeModal;